/** SMS Grup Portal – Sürüm Notları API istemcisi.
 * localStorage kullanılmaz. axiosConfig token/baseURL interceptor'unu kullanır.
 * src/pages/ altında duruyorsa ../axiosConfig yolu uygundur.
 */
import axiosInstance from "../../api/axiosConfig"; // Projenize göre import yolunu kontrol edin.

const CHANGED_EVENT = "smsgrup:release-notes-changed";

export const RELEASE_NOTE_TYPES = [
  { value: "NEW", label: "Yeni özellik", color: "teal" },
  { value: "IMPROVEMENT", label: "İyileştirme", color: "blue" },
  { value: "FIX", label: "Hata düzeltmesi", color: "orange" },
  { value: "SECURITY", label: "Güvenlik", color: "grape" },
];
export const RELEASE_MODULES = [
  "Genel", "BT Destek", "İnsan Kaynakları", "Gayrimenkul", "Dosya Paylaşım",
  "Satın Alma", "Filo Yönetimi", "İdari İşler", "Abonelik Takibi",
  "Beton Takibi", "Öğrenci Bursları", "Aile Yardımları", "Diğer",
];

export const getLocalDate = () => {
  const now = new Date();
  const offset = now.getTimezoneOffset() * 60_000;
  return new Date(now.getTime() - offset).toISOString().slice(0, 10);
};

function makeId() {
  return (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function")
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}

export const makeChangeItem = () => ({
  id: makeId(), type: "NEW", module: "Genel", title: "", description: "",
});

export const makeRelease = () => ({
  id: makeId(), version: "", title: "", summary: "", publishedAt: getLocalDate(),
  status: "DRAFT", items: [makeChangeItem()], createdAt: null, updatedAt: null,
});

export const releaseErrorMessage = (error) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || "Alan hatası").join("; ");
  if (error?.response?.status === 401) return "Oturumunuz sona ermiş. Yeniden giriş yapın.";
  if (error?.response?.status === 403) return "Bu işlem için yönetici yetkiniz bulunmuyor.";
  return error?.message || "Sunucu ile iletişim kurulamadı.";
};

export async function listReleaseNotes() {
  const { data } = await axiosInstance.get("/admin/release-notes");
  return Array.isArray(data) ? data : [];
}

export async function listPublishedReleaseNotes() {
  const { data } = await axiosInstance.get("/release-notes");
  return Array.isArray(data) ? data : [];
}

function notifyChange() {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(CHANGED_EVENT));
}

/** id gerçek DB id'si değilse POST; kayıtlıysa PUT. */
export async function upsertReleaseNote(input) {
  const payload = {
    version: String(input.version || "").trim().replace(/^v/i, ""),
    title: String(input.title || "").trim(),
    summary: String(input.summary || "").trim(),
    status: input.status,
    publishedAt: input.publishedAt || null,
    items: input.items.map((item) => ({
      id: item.id,
      type: item.type,
      module: String(item.module || "").trim(),
      title: String(item.title || "").trim(),
      description: String(item.description || "").trim(),
    })),
  };
  const persisted = Number.isInteger(input.id) && input.id > 0;
  const { data } = persisted
    ? await axiosInstance.put(`/admin/release-notes/${input.id}`, payload)
    : await axiosInstance.post("/admin/release-notes", payload);
  notifyChange();
  return data;
}

export async function removeReleaseNote(id) {
  await axiosInstance.delete(`/admin/release-notes/${id}`);
  notifyChange();
  return true;
}

export function subscribeReleaseNotes(listener) {
  if (typeof window === "undefined") return () => {};
  window.addEventListener(CHANGED_EVENT, listener);
  return () => window.removeEventListener(CHANGED_EVENT, listener);
}

export function sortPublishedReleases(releases) {
  return [...releases].filter((r) => r.status === "PUBLISHED").sort((a, b) => {
    const dateOrder = String(b.publishedAt || "").localeCompare(String(a.publishedAt || ""));
    if (dateOrder) return dateOrder;
    const toNum = (v) => String(v || "").split(/[.+-]/).slice(0, 3).map((n) => Number(n) || 0);
    const av = toNum(a.version), bv = toNum(b.version);
    for (let i = 0; i < 3; i += 1) if (av[i] !== bv[i]) return bv[i] - av[i];
    return Number(b.id) - Number(a.id);
  });
}
